export const SET_YEARMONTH = "SET_YEARMONTH";

export interface YearmonthState {
  yearmonth: string;
  error: boolean;
}
